const offersEligibilityLocale = {
  offersEligibility: {
    title: "Offres adhérents",
    offers: "Offre concernée",
    conditionList: "Liste des conditions pour l'offre : {condition}",
    condition: "Conditions",
    conditionStatus: "Eligibilité adhérent",
  },
};

export type OffersEligibilityLocale = typeof offersEligibilityLocale;
export default offersEligibilityLocale;
